export default class Api {

    _axios = null;

  constructor (Vue, options) {
    let {
        axios,
      } = options || {
        axios: false,
      };
    this._axios = axios;
    this._axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
    Vue.prototype.$api = this;
  }

    login(account, password) {
      return this._axios.post('/auth', { account: account, password: password });
    }
    getDocuments(params) {
        return this._axios.get("/spa/documents", { params });
    }
    getDocument(params) {
        return this._axios.get("/spa/documents/"+params, { responseType: 'blob' });
    }
    getClaims(params) {
      return this._axios.get("/spa/offers", { params } );
    }
    searchClaims(params) {
        return this._axios.get("/spa/offers/search", { params });
    }
    getDealer(params) {   
        return this._axios.get("/spa/dealers", { params });
    }
    createOffer(offer) {
        return this._axios.post("/spa/offers", { offer });
    }
    createContract(offer) {
      return this._axios.post("/spa/offers/"+offer.id+"/contract", { offer });
    }
    submitContract(offer) {
      return this._axios.post("/spa/offers/"+offer.id+"/submit_contract", { offer });
    }
    searchOffers(params) {
      return this._axios.get("/spa/offers/search", { params });
    }
    getOffers(params) {
      return this._axios.get("/spa/offers/offers", { params });
    }
    getContracts(params) {
      return this._axios.get("/spa/offers/contracts", { params });
    }
    getSubmittedContracts(params) {
      return this._axios.get("/spa/offers/submitted_contracts", { params });
    }
    getOffer(params) {
        return this._axios.get("/spa/offers/"+params);
    }
    getOfferDocument(params,type) {
      return this._axios.get("/spa/offers/"+params+"?format=pdf&type="+type, { responseType: 'blob' });
    }
    getKravagLocations(params){
        return this._axios.get("/spa/offers/locations/autocomplete?&term="+params);
    }
    getParticipations(type){
      return this._axios.get("/spa/offers/participations?&type="+type);
    }
    getPaymentterms(){
      return this._axios.get("/spa/offers/paymentterms");
    }
    getInsurances(params){
      return this._axios.get("/spa/offers/insurances/autocomplete?&term="+params);
    }
    getCountries(params){
      return this._axios.get("/spa/offers/countries/autocomplete?&term="+params);
    }
    getCarData(hsn, tsn){
      return this._axios.get("/spa/offers/cardata?&hsn="+hsn+"&tsn="+tsn);
    }
    createOfferEvb(params) {
      return this._axios.post("/spa/evbs/offer", params, { responseType: 'blob' } );
    }
    createEvb(evb) {
      return this._axios.post("/spa/evbs", evb, { responseType: 'blob' } );
    }


    createSfOffer(offer) {
      return this._axios.post("/spa/softfair_offers", { offer });
    }


    getSfOffers(params){
      return this._axios.get("/spa/softfair_offers/"+params+"/sf");
    }

    getSfOffer(params){
      return this._axios.get("/spa/softfair_offers/"+params);
    }

    getSfOfferStatus(){
      return this._axios.get("/spa/softfair_offers/"+params+"/status");
    }

    getSfOfferResponseCount(){
      return this._axios.get("/spa/softfair_offers/"+params+"/response_count");
    }

    getSfInsuranceList(){
      return this._axios.get("/spa/softfair_offers/sfinsurances");
    }
    
}